/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type VerifyURLRequestBody = {
  /**
   * The https URL to probe.
   */
  clientIdMetadataUri: string;
};

/** @internal */
export type VerifyURLRequestBody$Outbound = {
  client_id_metadata_uri: string;
};

/** @internal */
export const VerifyURLRequestBody$outboundSchema: z.ZodMiniType<
  VerifyURLRequestBody$Outbound,
  VerifyURLRequestBody
> = z.pipe(
  z.object({
    clientIdMetadataUri: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientIdMetadataUri: "client_id_metadata_uri",
    });
  }),
);

export function verifyURLRequestBodyToJSON(
  verifyURLRequestBody: VerifyURLRequestBody,
): string {
  return JSON.stringify(
    VerifyURLRequestBody$outboundSchema.parse(verifyURLRequestBody),
  );
}
